import { useState } from 'react';
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';
import { Select } from 'antd';
import { useGameplayConfig } from 'store';
import { storage } from 'services/config/storage';
import { languageLabels } from './constants';
import { Dropdown } from 'assets/icons';
import "./style.scss"

const LanguageSelect = ({ visible,
    className = "",
    selectClassName = "",
    onLanguageChange,
    showLanguageLabel = true,
}) => {
    const { languagesOptions, setConfigLanguageSettings } = useGameplayConfig()
    const { t } = useTranslation()
    const [isDropdownOpen, setIsDropdownOpen] = useState(false)

    const handleLanguageChange = async (val) => {
        const isRtlLayout = val === 'ar' ? true : false
        setConfigLanguageSettings({
            configLanguage: val,
            layoutDirection: isRtlLayout ? 'rtl' : 'ltr',
            isRtlLayout
        })
        i18n.changeLanguage(val)
        storage.set.userLang(val)
        
        if (onLanguageChange) {
            onLanguageChange(val)
        }
        setIsDropdownOpen(false)
    }

    return visible ? (
        <div className={`flex flex-col items-start ${className}`}>
            {showLanguageLabel && <p className="size-16 color-primary weight-400 m-0 mb-8 opacity-70">{t("login_screen.choose_language")}</p>}
            <Select
                open={isDropdownOpen}
                onDropdownVisibleChange={setIsDropdownOpen}
                suffixIcon={
                    <span
                        className="language-select-arrow"
                        onMouseDown={(event) => {
                            event.preventDefault()
                            event.stopPropagation()
                            setIsDropdownOpen((isOpen) => !isOpen)
                        }}
                    >
                        <Dropdown />
                    </span>
                }
                className={`language-select ${selectClassName}`}
                popupClassName="language-select-popup"
                value={i18n?.language}
                options={languagesOptions?.map(lang => ({ value: lang, label: languageLabels[lang] }))}
                onChange={handleLanguageChange}
            />
        </div>
    ) : (<></>)
}

export default LanguageSelect
